"use client";

import { ExecutiveSummarySection } from "@/components/sections/executive-summary";
import { executiveSummary } from "@/lib/data/services-competitive-intelligence";

export function ExecutiveSummary() {
  return (
    <ExecutiveSummarySection
      eyebrow={executiveSummary.eyebrow}
      title={executiveSummary.title}
      intro={executiveSummary.intro}
      paragraphs={executiveSummary.paragraphs}
      metrics={executiveSummary.metrics}
      cta={executiveSummary.cta}
      primaryAccent="var(--color-purple)"
    />
  );
}